"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAirQuality = void 0;
const react_1 = require("react");
const queries_1 = require("../graphql/queries");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
const useAirQuality = () => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const fetchAirQuality = async (latitude, longitude) => {
        setLoading(true);
        setError(null);
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.getAirQuality,
                variables: { latitude, longitude },
            });
            if ('data' in response && response.data?.getAirQuality) {
                return response.data.getAirQuality;
            }
            throw new Error('No air quality data received');
        }
        catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to fetch air quality data';
            console.error('Error fetching air quality data:', err);
            setError(errorMessage);
            throw new Error(errorMessage);
        }
        finally {
            setLoading(false);
        }
    };
    return { fetchAirQuality, loading, error };
};
exports.useAirQuality = useAirQuality;
